module.exports = __webpack_public_path__ + "static/media/col2row2.fa71189b.jpg";